@if (userInitials) {
  <div class="user-initials">
    {{ userInitials }}
  </div>
}
